export { default as Input } from "./Input";
export { default as Select } from "./Select";
export { default as TextArea } from "./TextArea";
export { default as Recaptcha } from "./Recaptcha";

export const Types = {
    Text: "text",
    Phone: "tel",
    Email: "email",
    Number: "number",
    Select: "select",
    TextArea: "textarea",
};
